"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRerenderOnStateChange = void 0;
var useEvt_1 = require("./useEvt");
var React = __importStar(require("react"));
var useState = React.useState;
;
/**
 * https://docs.evt.land/react-hooks#usererenderonstatechange
 *
 * To use StatefulEvt as react component state.
 * */
function useRerenderOnStateChange(evt) {
    //NOTE: We use function in case the state is a function
    var _a = __read(useState(function () { return evt.state; }), 2), setState = _a[1];
    (0, useEvt_1.useEvt)(function (ctx) {
        return evt.attach(ctx, function (state) { return setState(function () { return state; }); });
    }, [evt]);
}
exports.useRerenderOnStateChange = useRerenderOnStateChange;
//# sourceMappingURL=useRerenderOnStateChange.js.map